import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from '@/locales/en/translation.json';
import translationVI from '@/locales/vi/translation.json';
import translationZH from '@/locales/zh/translation.json';

const resources = {
  en: { translation: translationEN },
  vi: { translation: translationVI },
  zh: { translation: translationZH }
};

// || i18n.language 
const currentLang = localStorage.getItem('i18nextLng') || 'vi';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: currentLang,
    fallbackLng: currentLang,
    debug: false,
    resources,
    detection: {
      // ưu tiên lấy ngôn ngữ từ đâu
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // lưu ngôn ngữ đã chọn vào localStorage
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;